import React, { FC, useEffect, ReactNode } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { Spin } from 'antd';

import { AuthState, checkLoginStatus, getCheckLoginStatusState } from '../store/actions/auth';
import { MainReducerState } from '../store/reducers';

interface ProtectedRouteProps {
    fetchCheckLoginStatus: typeof checkLoginStatus.trigger;
    children: ReactNode;
    loginPath: string;
    checkLoginStatusState: AuthState['checkLoginStatus'];
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({
    checkLoginStatusState, fetchCheckLoginStatus, children, loginPath,
}) => {
    useEffect(() => {
        if (!checkLoginStatusState.hasCheckedLoginStatus) {
            fetchCheckLoginStatus();
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (checkLoginStatusState.hasCheckedLoginStatus && !checkLoginStatusState.isConnected) {
        return <Redirect to={loginPath} />;
    } else if (checkLoginStatusState.hasCheckedLoginStatus && checkLoginStatusState.isConnected) {
        return <>{children}</>;
    } else {
        return (
            <Route>
                <div id="initial-loader">
                    <Spin />
                </div>
            </Route>
        );
    }
};

const mapStateToProps = (state: MainReducerState) => ({
    checkLoginStatusState: getCheckLoginStatusState(state),
});

export default connect(
    mapStateToProps,
    {
        fetchCheckLoginStatus: checkLoginStatus.trigger,
    },
)(ProtectedRoute);
